import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Embeds Daily Prebuilt (loaded on demand) once a Daily.co key is configured on the backend.
export default function CallFrame({ roomUrl, token, onLeave }) {
  const host = useRef();
  useEffect(() => {
    let frame;
    let cancelled = false;
    const boot = async () => {
      if (!window.DailyIframe) {
        await new Promise((res, rej) => { const s = document.createElement("script"); s.src = "https://unpkg.com/@daily-co/daily-js"; s.onload = res; s.onerror = rej; document.head.appendChild(s); });
      }
      if (cancelled || !host.current) return;
      frame = window.DailyIframe.createFrame(host.current, { iframeStyle: { width: "100%", height: "70vh", border: "0" }, showLeaveButton: true });
      frame.on("left-meeting", onLeave);
      frame.join({ url: roomUrl, token });
    };
    boot().catch(() => onLeave());
    return () => { cancelled = true; frame && frame.destroy(); };
  }, [roomUrl, token, onLeave]);
  return (
    <Dialog open onOpenChange={(o) => !o && onLeave()}>
      <DialogContent className="max-w-5xl bg-black p-0" data-testid="call-frame">
        <DialogHeader><DialogTitle className="sr-only">Call</DialogTitle></DialogHeader>
        <div ref={host} className="min-h-[70vh] w-full" />
      </DialogContent>
    </Dialog>
  );
}
